export enum WhiteBloodCellDifferentialUnitType {
    PERCENT = 1,
    ABSOLUTE_KCELLS,
    ABSOLUTE_CELLS
}